import { render, staticRenderFns } from "./team-follow.vue?vue&type=template&id=43454bc2&scoped=true"
import script from "./team-follow.vue?vue&type=script&lang=js"
export * from "./team-follow.vue?vue&type=script&lang=js"
import style0 from "./team-follow.vue?vue&type=style&index=0&id=43454bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43454bc2",
  null
  
)

export default component.exports